import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import authService from './authService'

// Get user from localStorage
const user = JSON.parse(localStorage.getItem('user'))
const initialState = {
  user: user || '',
  isError: false,
  isSuccess: false,
  isLoading: false,
  errorMsg: '',

  // validate pageName
  pageNameState: '',
  nameLoading: false,
  nameSuccess:false,
 
  // create password
  createPassState: '',

  // reg user
  regUserState: '',
  regError: false,
  regSuccess: false,
  regLoading: false,
  regErrMsg: '',
  // Two Factor Authentication
  twoFactor: '',
  contactUsData: [],
  updateProfilePicData:'',
}

// registerUser user
export const registerUser = createAsyncThunk(
  'auth/registerUser',

  async (user, thunkAPI) => {
    try {
      return await authService.registerUser(user)
    } catch (error) {
      const errorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.errorMsg) ||
        error.errorMsg ||
        error.toString()
      return thunkAPI.rejectWithValue(errorMsg)
    }
  },
)
// validatePageName
export const validatePageName = createAsyncThunk(
  'auth/validatePageName',

  async (pageName, thunkAPI) => {
    try {
      return await authService.validatePageName(pageName)
    } catch (error) {
      const errorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.errorMsg) ||
        error.errorMsg ||
        error.toString()

      return thunkAPI.rejectWithValue(errorMsg)
    }
  },
)

// loginUser user
export const loginUser = createAsyncThunk(
  'auth/loginUser',
  async (user, thunkAPI) => {
    try {
      const res = await authService.loginUser(user);
      localStorage.setItem('user', JSON.stringify(res))
      return res
    } catch (error) {
      // alert('auth  cathch')
      const errorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.errorMsg) ||
        error.errorMsg ||
        error.toString()
      return thunkAPI.rejectWithValue(errorMsg)
    }
  },
)
// logout user
export const logoutUser = createAsyncThunk('auth/logoutUser', async () =>
  authService.logoutUser(),
)

// Create passoword user
export const createUserPassword = createAsyncThunk(
  'auth/createUserPassword',
  async (user, thunkAPI) => {
    try {
      return await authService.createUserPassword(user)
    } catch (error) {
      const errorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.errorMsg) ||
        error.errorMsg ||
        error.toString()
      return thunkAPI.rejectWithValue(errorMsg)
    }
  },
)

// resetpassoword user
export const resetUserPassword = createAsyncThunk(
  'auth/resetUserPassword',
  async (user, thunkAPI) => {
    try {
      return await authService.resetUserPassword(user)
    } catch (error) {
      const errorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.errorMsg) ||
        error.errorMsg ||
        error.toString()
      return thunkAPI.rejectWithValue(errorMsg)
    }
  },
)

export const twoFactorAuthentication = createAsyncThunk(
  'auth/twoFactorAuthentication',
  async (_, thunkAPI) => {
    try {
      return await authService.twoFactorAuthentication()
    } catch (error) {
      const errorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.errorMsg) ||
        error.errorMsg ||
        error.toString()
      return thunkAPI.rejectWithValue(errorMsg)
    }
  },
)

export const verifyTwoFactor = createAsyncThunk(
  'auth/verifyTwoFactor',
  async (data, thunkAPI) => {
    try {
      return await authService.verifyTwoFactor(data)
    } catch (error) {
      const errorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.errorMsg) ||
        error.errorMsg ||
        error.toString()
      return thunkAPI.rejectWithValue(errorMsg)
    }
  },
)

export const contactUs = createAsyncThunk(
  'auth/contactUs',
  async (data, thunkAPI) => {
    try {
      return await authService.contactUs(data)
    } catch (error) {
      const errorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.errorMsg) ||
        error.errorMsg ||
        error.toString()
      return thunkAPI.rejectWithValue(errorMsg)
    }
  },
)

export const updateProfilePic = createAsyncThunk(
  'auth/updateProfilePic',
  async (data, thunkAPI) => {
    try {
      return await authService.updateProfilePic(data)
    } catch (error) {
      const errorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.errorMsg) ||
        error.errorMsg ||
        error.toString()
      return thunkAPI.rejectWithValue(errorMsg)
    }
  },
)



export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    resetUser: (state) => {
      state.contactUsData = []
      state.isLoading = false
      state.isSuccess = false
      state.isError = false
      state.errorMsg = ''
      state.regSuccess = false
      state.regErrMsg = ''

      state.nameLoading = false
      state.nameSuccess = false

      state.regError = false
      state.regLoading = false
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(validatePageName.pending, (state) => {
        state.nameLoading = true
      })
      .addCase(validatePageName.fulfilled, (state, action) => {
        state.nameLoading = false
        state.nameSuccess = true
        state.pageNameState = action.payload
      })
      .addCase(validatePageName.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.errorMsg = action.payload
        // state.user = null
      })
      .addCase(registerUser.pending, (state) => {
        state.regLoading = true
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.regLoading = false
        state.regSuccess = true
        state.regUserState = action.payload
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.regLoading = false
        state.regError = true
        state.regErrMsg = action.payload
        // state.user = null
      })
      .addCase(loginUser.pending, (state) => {
        state.isLoading = true
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.user = action.payload
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.errorMsg = action.payload
        // state.user = null
      })
      .addCase(logoutUser.pending, (state) => {
        state.isLoading = true
      })
      .addCase(logoutUser.fulfilled, (state, action) => {
        state.isSuccess = true
        state.isLoading = false
        state.user = action.payload
      })
      .addCase(logoutUser.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.isSuccess = false
        state.errorMsg = action.payload
      })

      // Create password
      .addCase(createUserPassword.pending, (state) => {
        state.isLoading = true
      })
      .addCase(createUserPassword.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.createPassState = action.payload
      })
      .addCase(createUserPassword.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.isSuccess = false
        state.errorMsg = action.payload
      })

      // resetpassword
      .addCase(resetUserPassword.pending, (state) => {
        state.isLoading = true
      })
      .addCase(resetUserPassword.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.user = action.payload
      })
      .addCase(resetUserPassword.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.isSuccess = false
        state.errorMsg = action.payload
      })

      .addCase(twoFactorAuthentication.pending, (state) => {
        state.isLoading = true
      })
      .addCase(twoFactorAuthentication.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.twoFactor = action.payload
      })
      .addCase(twoFactorAuthentication.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.isSuccess = false

        state.errorMsg = action.payload
      })
      .addCase(verifyTwoFactor.pending, (state) => {
        state.isLoading = true
      })
      .addCase(verifyTwoFactor.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.verifyUser = action.payload
      })
      .addCase(verifyTwoFactor.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.isSuccess = false

        state.errorMsg = action.payload
      })

      .addCase(contactUs.pending, (state) => {
        state.isLoading = true
      })
      .addCase(contactUs.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.contactUsData = action.payload
      })
      .addCase(contactUs.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.isSuccess = false

        state.errorMsg = action.payload
      })
     
      .addCase(updateProfilePic.pending, (state) => {
        state.isLoading = true
      })
      .addCase(updateProfilePic.fulfilled, (state, action) => {
        state.isLoading = false
        state.isSuccess = true
        state.updateProfilePicData = action.payload
      })
      .addCase(updateProfilePic.rejected, (state, action) => {
        state.isLoading = false
        state.isError = true
        state.isSuccess = false

        state.errorMsg = action.payload
      })
  },
})

export const { resetUser } = authSlice.actions
export default authSlice.reducer
